// extracted by mini-css-extract-plugin
module.exports = {"DocumentFormModal":"DocumentFormModal_DocumentFormModal__2W5Fc","Accordion":"DocumentFormModal_Accordion__MTb7n"};